import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
class Index extends React.Component {
    state = {
        checkNick: false,
    };
    componentDidMount() {
        document.title = "Troubleshooting"
    };
    handhash(){
        var text = window.location.hash

        
    }
    
    render() {
        
        return (
            <App onhashchange={this.handhash}/>
        );
    }
}

ReactDOM.render(<Index/>, document.getElementById('root'));




// WEBPACK FOOTER //
// ./src/index.js